import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  favorites: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_FAVORITES_DATA:
      return { ...state, favorites: action.data || [] };
    case actionTypes.SET_ACTIVITIES:
      return { ...state, activities: action.data };
    default:
      return state;
  }
};
